import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        'text-s-huge',
        'text-s-h1',
        'text-s-h2',
        'text-s-h3',
        'text-s-h4',
        'text-s-h5',
        'text-s-h6',
        'text-s-h6s',

        'text-d-huge',
        'text-d-h1',
        'text-d-h2',
        'text-d-h3',
        'text-d-h4',
        'text-d-h5',
        'text-d-h6',
        'text-d-menu',
        'text-d-menu-secondary',

        'text-huge',
        'text-h1',
        'text-h2',
        'text-h3',
        'text-h4',
        'text-h5',
        'text-h6',
        'text-large',
        'text-regular',
        'text-small',
        'text-caption',
        'text-overline',
        'text-menu',
        'text-menu-secondary'
      ],
      size: [
        'size-[8px]',
        'size-[12px]',
        'size-[16px]',
        'size-[24px]',
        'size-[32px]',
        'size-[48px]',
        'size-[64px]'
      ]
    }
  }
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
